import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { followUpProjectTicket } from '../../api';
export default {
  name: 'ticketFollowUpDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      form: {
        id: null,
        remark: ''
      },
      loading: false,
      rules: {
        remark: [{
          required: true,
          validator: function validator(rule, value, callback) {
            value && value.trim() ? callback() : callback(new Error('请输入跟进记录'));
          },
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    open: function open(id) {
      var _this = this;
      this.form = {
        id: id,
        remark: ''
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.form && _this.$refs.form.clearValidate();
      });
    },
    handleClosed: function handleClosed() {
      this.form.remark = '';
      this.$emit('update:visible', false);
    },
    submit: function submit() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var valid;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.n = 1;
              return new Promise(function (resolve) {
                return _this2.$refs.form.validate(resolve);
              });
            case 1:
              valid = _context.v;
              if (valid) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _this2.loading = true;
              _context.p = 3;
              _context.n = 4;
              return followUpProjectTicket({
                id: _this2.form.id,
                remark: _this2.form.remark.trim()
              });
            case 4:
              _this2.$message.success('跟进成功');
              _this2.$emit('update:visible', false);
              _this2.$emit('success');
            case 5:
              _context.p = 5;
              _this2.loading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[3,, 5, 6]]);
      }))();
    }
  }
};